$(document).ready(function() {
  $('.header__search-link').on('click', function() {
    $('.search-header').addClass('is-open');
    document.getElementById('suggestion__section').style.display = 'block';
  })
  $('.search-close__wrapper').on('click', function() {
    $('.search-header').removeClass('is-open');
  })
  $('#search_mobile').on('click',function() {
    $('.menu-drawer__inner-container').css('display', 'none');
    $('.popular_recent_search_mobile__wrapper').css('display', 'block');
  })
  $('.close_search_content').on('click', function() {
    $('.popular_recent_search_mobile__wrapper').css('display', 'none');
    $('.menu-drawer__inner-container').css('display', 'block');
  })
  $('.close_search__text').on('click', function() {
    $('.search-field').val('');
    $(this).css('display', 'none');
    $('.product-match__section').css('display', 'none');
    $('.popular_recent_search_mobile__wrapper').css('display', 'block');
  })
})